import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCheckCircle, faChevronLeft, faChevronRight, faMagnifyingGlass, faXmarkCircle } from '@fortawesome/free-solid-svg-icons';

export default function UserWallet() {

    const generateWeek = () => {
        const today = new Date();
        const currentMonth = today.getMonth();
        const startOfWeek = new Date(today.setDate(today.getDate() - today.getDay())); // Start on Sunday
        const week = [];

        for (let i = 0; i < 7; i++) {
            const date = new Date(startOfWeek);
            date.setDate(startOfWeek.getDate() + i);

            // Only add dates in current month
            if (date.getMonth() === currentMonth) {
                week.push({
                    date,
                    isAvailable: [1, 3].includes(date.getDay()), // Available on Mon/Wed/Fri
                });
            }
        }
        return week;
    };

    const [active, setActive] = useState('div1')

    const [showAllAppointments, setShowAllAppointments] = useState(false);

    const Appointment = [
        { therapy_name: 'Physiotherapy ', time: '6 May 2024' },
        { therapy_name: 'Physiotherapy ', time: '6 May 2024' },
        { therapy_name: 'Spa therapy', time: '2 April 2024' },
        { therapy_name: 'Spa therapy', time: '2 April 2024' },
        { therapy_name: 'Spa therapy', time: '2 April 2024' },
    ]

    const sampleTransactions = [
        {
            date: '2025-07-20',
            SessionId: 'ABC123456789XYZ',
            therapy: 'Speech Therapy',
            status: 'Completed',
            reports: 'Uploaded',
        },
        {
            date: '2025-07-18',
            SessionId: 'SESSION987654321',
            therapy: 'Occupational Therapy',
            status: 'Pending',
            reports: 'Not Uploaded',
        },
        {
            date: '2025-07-15',
            SessionId: 'TH12345XYZ',
            therapy: 'Behavioral Therapy',
            status: 'Completed',
            reports: 'Uploaded',
        },
        {
            date: '2025-07-10',
            SessionId: 'SESSION1234ABC5678',
            therapy: 'Physical Therapy',
            status: 'Completed',
            reports: 'Not Uploaded',
        },
        {
            date: '2025-07-08',
            SessionId: 'SKL456789XYZ001',
            therapy: 'Cognitive Therapy',
            status: 'Pending',
            reports: 'Uploaded',
        },
    ];

    const [transactions, setTransactions] = useState(sampleTransactions);
    const [searchTerm, setSearchTerm] = useState('');


    const [currentPage, setCurrentPage] = useState(1);
    const [entitiesPerPage, setEntitiesPerPage] = useState(3);

    const filteredTransactions = transactions.filter((txn) =>
        Object.values(txn).some(val =>
            typeof val === 'string' && val.toLowerCase().includes(searchTerm.toLowerCase())
        )
    );


    const indexOfLastEntity = currentPage * entitiesPerPage;
    const indexOfFirstEntity = indexOfLastEntity - entitiesPerPage;
    const currentEntities = filteredTransactions.slice(indexOfFirstEntity, indexOfLastEntity);
    const emptyRowCount = entitiesPerPage - currentEntities.length;

    const handlePrevClick = () => {
        setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
    };

    const handleNextClick = () => {
        setCurrentPage(prevPage => {
            const totalPages = Math.ceil(transactions.length / entitiesPerPage);
            return Math.min(prevPage + 1, totalPages);
        });
    };

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleDropdownChange = (e) => {
        setEntitiesPerPage(parseInt(e.target.value));
        setCurrentPage(1);
    };

    const totalPages = Math.ceil(transactions.length / entitiesPerPage);
    const maxPageNumbersToShow = 5;
    const startPage = Math.max(currentPage - Math.floor(maxPageNumbersToShow / 2), 1);
    const endPage = Math.min(startPage + maxPageNumbersToShow - 1, totalPages);
    const pageNumbers = [];

    for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
    }

    return (
        <div className="relative mt-5 border border-[#5C1FE2] rounded-xl p-5">
            {/* Blur Overlay for this section only */}
            <div className="absolute inset-0 bg-black/70 backdrop-blur-md z-10 flex items-center justify-center rounded-xl">
                <div className="text-center">
                    <h1 className="text-4xl md:text-5xl font-bold text-white tracking-wide animate-pulse">
                        Coming Soon
                    </h1>
                    <p className="mt-4 text-base md:text-lg text-white/80">
                        We're working hard to bring you this feature!
                    </p>
                    <div className="mt-6 flex justify-center">
                        <div className="w-16 h-1 bg-gradient-to-r from-[#5C1FE2] to-[#834CFF] rounded-full animate-pulse"></div>
                    </div>
                </div>
            </div>

            {/* Original Content */}
            <div className='flex flex-col lg:flex-row gap-10 items-center'>
                <div className='w-[100%] lg:w-[35%]'>
                    <div className='bg-[#141414] p-6 rounded-3xl relative mt-[65px] pt-[100px]'>

                        <div className='absolute rounded-full -top-[65px] left-[50%] -translate-x-[50%] border-2 p-2'>
                            <img src='https://i.pravatar.cc/100?img=10' className='w-[125px] h-[125px] rounded-full border-2'></img>
                        </div>
                        <p className='uppercase text-center text-2xl font-semibold'>CHRISTIANO  RONALDO </p>
                        <p className='text-center mt-1 text-sm'>GLDX ID: <span className='text-[#00FF0A]'>GLDX-001-007</span></p>
                        <div className='rounded-full p-1.5 border border-[#817E7E] mt-7 flex items-center justify-between gap-1'>
                            <div className='w-14 h-14 border border-[#817E7E] rounded-full grid place-content-center p-1'>
                                <img src='/assets/icon/handfile.svg'></img>
                            </div>
                            <p className='flex flex-col font-medium text-sm lg:text-base'>Treatment History
                                <span className='text-xs font-light'>12 entries</span>
                            </p>
                            <button className='underline text-sm cursor-pointer mr-2 lg:mr-5'>View </button>
                        </div>
                        <div className='flex justify-evenly mt-7 text-center '>
                            <div>
                                <p className='text-3xl font-medium'>A<span>+</span></p>
                                <p>Blood Type</p>
                            </div>
                            <div className='h-14 w-[1px] bg-white'></div>
                            <div>
                                <p className='text-3xl font-medium'>35</p>
                                <p>Years old</p>
                            </div>
                        </div>
                        <div className='mt-10 flex justify-center'>
                            <button className='border-2 rounded-full py-2 px-10 cursor-pointer'>Health Report</button>
                        </div>
                    </div>
                </div>
                <div className='w-[100%] lg:w-[65%] grid grid-cols-1 lg:grid-cols-2 gap-5'>
                    <div className='p-5 border rounded-3xl grid content-around'>
                        <p className='text-xl font-medium'>Appointments</p>
                        <div>
                            <p className="text-end text-base font-medium flex justify-between items-center">
                                <p className='text-xs'>Upcoming this week</p>
                                {new Date().toLocaleString('default', { month: 'long' })}
                            </p>
                            <div className="flex gap-2 my-2 justify-center">
                                {generateWeek().map((day, index) => (
                                    <div
                                        key={index}
                                        className={`text-center w-7 lg:w-10 py-2 rounded-full text-sm font-medium border ${day.isAvailable
                                            ? 'bg-[#00FF00] text-black border-transparent'
                                            : 'border-white'
                                            }`}
                                    >
                                        {day.date.getDate()}
                                    </div>
                                ))}
                            </div>
                            <div className="flex gap-2 justify-center text-xs font-medium mb-2">
                                {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day, index) => (
                                    <div key={index} className="w-7 lg:w-10 text-center">
                                        {day}
                                    </div>
                                ))}
                            </div>
                        </div>
                        {active === 'div1' &&
                            <>
                                <p><span><input type='checkbox' className='translate-y-[1px] mr-1 text-sm'></input></span> I confirm my appointment date & time.</p>
                                <button className='mt-2 w-full bg-[#5F33D6] flex items-center justify-center gap-3 py-2 border border-white/15 rounded-full relative overflow-hidden text-lg font-medium'>
                                    <div className='w-[90%] h-2 rounded bg-white absolute top-1 blur-lg'></div>
                                    <img src='/assets/icon/magic.svg'></img> Book Appointment
                                </button>
                            </>
                        }
                        {active === 'div2' &&
                            <>
                                <p className='font-medium'>Sessions Booked</p>
                                <div>
                                    <p className='flex justify-between'>
                                        <span className='flex items-center gap-3'>
                                            <div className='w-4 h-4 text-[8px] font-bold rounded-full border grid place-content-center'><FontAwesomeIcon icon={faCheck} className='text-[#00ff00]' /></div>
                                            Treatment 1</span>
                                        <span>Mon, 15</span>
                                    </p>
                                    <div className='border-l border-dashed h-3 w-[2px] translate-x-2 -translate-y-0'></div>
                                    <p className='flex justify-between'>
                                        <span className='flex items-center gap-3'>
                                            <div className='w-4 h-4 text-[8px] font-bold rounded-full border grid place-content-center'></div>
                                            Treatment 2</span>
                                        <span>Tue, 16</span>
                                    </p>
                                </div>
                            </>
                        }
                    </div>
                    <div className='lg:pl-5'>
                        <div className={`${Appointment.length > 3 ? 'space-y-1' : 'space-y-3'}`}>
                            {Appointment.slice(0, 3).map((item, index) => (
                                <div key={index} className='rounded-full p-1.5 border border-[#817E7E] flex items-center gap-10'>
                                    <div className='w-14 h-14 border border-[#817E7E] rounded-full grid place-content-center p-1'>
                                        <img src='/assets/icon/file.svg' className='w-7'></img>
                                    </div>
                                    <p className='flex flex-col font-medium'><span>{item.therapy_name}<FontAwesomeIcon icon={faCheckCircle} className='text-xs text-[#00FF04] ml-1' /></span>
                                        <span className='text-xs font-light'>{item.time}</span>
                                    </p>
                                </div>
                            ))}
                        </div>
                        {showAllAppointments && (
                            <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                                <div className="bg-black rounded-xl p-5 max-w-md w-full" data-aos='fade-in' data-aos-duration='1000'>
                                    <div className="flex justify-between items-center mb-4">
                                        <p className="text-lg font-semibold">All Appointments</p>
                                        <button onClick={() => setShowAllAppointments(false)} className="text-gray-500 text-sm"><FontAwesomeIcon icon={faXmarkCircle} /></button>
                                    </div>

                                    <div className="space-y-3 max-h-[400px] overflow-y-auto">
                                        {Appointment.map((item, index) => (
                                            <div key={index} className='rounded-full p-1.5 border border-[#817E7E] flex items-center gap-10'>
                                                <div className='w-14 h-14 border border-[#817E7E] rounded-full grid place-content-center p-1'>
                                                    <img src='/assets/icon/file.svg' className='w-7' />
                                                </div>
                                                <p className='flex flex-col font-medium'>
                                                    <span>
                                                        {item.therapy_name}
                                                        <FontAwesomeIcon icon={faCheckCircle} className='text-xs text-[#00FF04] ml-1' />
                                                    </span>
                                                    <span className='text-xs font-light'>{item.time}</span>
                                                </p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                        {Appointment.length > 3 && (
                            <div className='text-center'><button
                                onClick={() => setShowAllAppointments(true)}
                                className="mt-2 text-sm text-white/80 underline"
                            >
                                + {Appointment.length - 3} more
                            </button></div>
                        )}
                    </div>
                    <div className='col-span-1 lg:col-span-2 border border-[#834CFF] rounded-3xl shadow-md shadow-black/25'>
                        <p className='font-medium text-2xl text-center py-3 border-b'>History Of Sessions</p>
                        <div className='rounded-xl overflow-hidden overflow-x-auto'>
                            <table className='w-full text-center'>
                                <thead className='uppercase text-sm border-b py-3'>
                                    <tr>
                                        <th className='py-3 px-3 lg:px-0 font-semibold'>Date & Time</th>
                                        <th className='py-3 px-3 lg:px-0 font-semibold'>Session Id</th>
                                        <th className='py-3 px-3 lg:px-0 font-semibold'>Therapy Name</th>
                                        <th className='py-3 px-3 lg:px-0 font-semibold'>Status</th>
                                        <th className='py-3 px-3 lg:px-0 font-semibold'>Reports</th>

                                    </tr>
                                </thead>
                                <tbody className=''>
                                    {currentEntities.map((entity, index) => (
                                        <tr key={index} className='h-16 text-sm 2xl:text-base text-center rounded-md font-bold font-normal'>
                                            <td className='px-5 md:px-0'>{entity.date}</td>
                                            <td className='px-5 md:px-0 relative group cursor-pointer'>
                                                <span>{entity.SessionId.length > 10 ? entity.SessionId.slice(0, 10) + "..." : entity.SessionId.slice(0, 10)}</span>
                                                <div className={`absolute -bottom-2 mb-2 left-1/2 -translate-x-1/2 w-max max-w-xs bg-black text-white text-xs px-3 py-1 rounded-md opacity-0 transition-opacity z-10 whitespace-nowrap
                                                ${entity.SessionId.length > 10 ? 'group-hover:opacity-100' : 'group-hover:opacity-0'}`}>
                                                    {entity.SessionId}
                                                </div>
                                            </td>
                                            <td className='px-5 md:px-0'>{entity.therapy}</td>
                                            <td className='px-5 md:px-0'>
                                                <span className={`rounded-full px-3 py-1 ${entity.status === 'Completed' ? 'text-[#00FF0A] bg-[#00FF0A]/20' : 'text-[#FF0000] bg-[#FF0000]/20'}`}>{entity.status}</span>
                                            </td>
                                            <td className={`px-5 md:px-0 ${entity.reports === 'Uploaded' ? 'text-[#00FF0A]' : 'text-[#FF0000]'}`}>{entity.reports}</td>
                                        </tr>
                                    ))}
                                    {Array.from({ length: emptyRowCount }).map((_, index) => (
                                        <tr key={`empty-${index}`} className='h-16'>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className='flex flex-col md:flex-row gap-3 md:gap-0 justify-between items-center py-3 px-5 border-t border-white/20'>
                            <div className='flex items-center'>
                                <p className='text-end text-sm px-3 my-auto'>Showing
                                    <select className='ml-2 outline-none rounded-md bg-transparent border-[1px]' onChange={handleDropdownChange} value={entitiesPerPage}>
                                        <option className='text-black' value="3">3</option>
                                        <option className='text-black' value="5">5</option>
                                        <option className='text-black' value="7">7</option>
                                    </select>
                                    <span className='ml-2'>of <span className='ml-1'>{totalPages}</span></span>
                                </p>
                            </div>
                            <div className='flex justify-end gap-3 text-xs px-3'>
                                <div className='my-auto flex justify-center items-center gap-1'>
                                    <FontAwesomeIcon icon={faChevronLeft} className='cursor-pointer bg-[#F1F2F6]/15 px-2.5 py-1.5 rounded shadow' onClick={handlePrevClick} />
                                    {pageNumbers.map((pageNumber) => (
                                        <button
                                            key={pageNumber}
                                            className={`px-2.5 py-1 rounded shadow ${pageNumber === currentPage ? 'font-bold bg-[#834CFF]' : 'bg-[#F1F2F6]/15'}`}
                                            onClick={() => handlePageClick(pageNumber)}
                                        >
                                            {pageNumber}
                                        </button>
                                    ))}
                                    <FontAwesomeIcon icon={faChevronRight} className='cursor-pointer bg-[#F1F2F6]/15 px-2.5 py-1.5 rounded shadow' onClick={handleNextClick} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
